import { useEffect, useState } from "react";
import { X, Flame } from "lucide-react";
import { ShareWinCard } from "./ShareWinCard";
import { ReferralNudge } from "./ReferralNudge";

const MILESTONES = [30, 7];

export function checkStreakMilestone(streak) {
  const m = MILESTONES.find((v) => streak === v);
  if (!m) return null;
  const key = `ss_celebrated_${m}`;
  const today = new Date().toISOString().slice(0, 10);
  if (localStorage.getItem(key) === today) return null;
  localStorage.setItem(key, today);
  return m;
}

export const StreakCelebration = ({ milestone, childName, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 50);
    return () => clearTimeout(t);
  }, []);

  if (!milestone) return null;
  const big = milestone >= 30;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-5 bg-black/60" data-testid="streak-celebration-modal">
      <div className={`relative w-full max-w-sm bg-white border-2 border-black rounded-3xl shadow-[8px_8px_0px_rgba(0,0,0,1)] p-7 text-center space-y-4 transition-all duration-300 ${show ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
        <button onClick={onClose} data-testid="streak-celebration-close" className="absolute top-3 right-3 p-1.5 bg-white border-2 border-black rounded-full active:translate-y-[2px] transition-transform">
          <X size={16} />
        </button>
        <div className="relative inline-block">
          <img src="/mascot.png" alt="mascot celebrating" className="w-28 h-28 mx-auto rounded-full border-4 border-black shadow-[4px_4px_0px_rgba(0,0,0,1)] bg-white object-cover animate-bounce-soft" />
          <span className="absolute -top-2 -right-2 bg-[#FF6B6B] text-white border-2 border-black rounded-full p-2">
            <Flame size={18} />
          </span>
        </div>
        <p className="font-heading text-4xl font-bold">{milestone}-DAY STREAK!</p>
        <p className="text-sm text-gray-700 font-medium">
          {big
            ? `${childName || "You"} showed up for a WHOLE MONTH. That's not luck — that's a new habit. Mia is so proud she's doing backflips.`
            : `A full week of showing up, ${childName || "superstar"}! ADHD brains that show up daily beat cramming every time. Keep the flame alive!`}
        </p>
        <ShareWinCard
          stat={`${milestone} days`}
          title={big ? "One month streak!" : "One week streak!"}
          sub="Showed up every single day on StudySpark"
          color={big ? "#FF6B6B" : "#FFE066"}
          testId="share-streak-button"
          className="w-full"
        />
        <ReferralNudge />
      </div>
    </div>
  );
};
